import { STOCK_PRICE_TTL } from "@/constants/constants";

export function useLocalStorage() {
  function readData(key: string) {
    return localStorage.getItem(key);
  }

  function saveData(key: string, data: string) {
    localStorage.setItem(key, data);
  }

  function removeItem(key: string) {
    localStorage.removeItem(key);
  }

  const saveDataWithTTL = (key: string, value: any) => {
    const now = new Date();
    const expiry = now.getTime() + (Number(STOCK_PRICE_TTL) ?? 24) * 60 * 60 * 1000;

    const item = {
      value,
      expiry,
    };

    localStorage.setItem(key, JSON.stringify(item));
  };

  const getDataWithTTL = (key: string) => {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  };

  return {
    readData,
    saveData,
    removeItem,
    getDataWithTTL,
    saveDataWithTTL,
  };
}
